import { render } from "./ShukkaPreDetailPage.vue?vue&type=template&id=96cb91fa"
import script from "./ShukkaPreDetailPage.vue?vue&type=script&lang=js"
export * from "./ShukkaPreDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__